/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import baseUrl from "./baseUrl.js";
import axios from 'axios';
import QS from 'qs';
import router from '../router/index'
import {
	Encrypt,
	Decrypt
} from "./cryptojs.js";

axios.defaults.baseURL = baseUrl.APIHOST
axios.interceptors.request.use( //响应拦截
	async config => {
			// 每次发送请求之前判断vuex中是否存在token        
			// 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
			// 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断 

			// window.localStorage.removeItem('GAOYANGNONGYE_PC_ACCESS_TOKEN')
			var token = window.localStorage.getItem('GAOYANGNONGYE_PC_ACCESS_TOKEN')
			if (token) {
				var token_time = window.localStorage.getItem('GAOYANGNONGYE_PC_ACCESS_TOKEN_TIME')
				if (token_time) {
					var date1 = new Date(token_time);
					var date2 = new Date();
					if (date1 > date2) {
						token = token
					} else {
						token = ''
						window.localStorage.removeItem('GAOYANGNONGYE_PC_ACCESS_TOKEN')
						window.localStorage.removeItem('GAOYANGNONGYE_PC_USERINFO')
						window.localStorage.removeItem('GAOYANGNONGYE_PC_USERID')
					}
				} else {
					token = ''
					window.localStorage.removeItem('GAOYANGNONGYE_PC_ACCESS_TOKEN')
					window.localStorage.removeItem('GAOYANGNONGYE_PC_USERINFO')
					window.localStorage.removeItem('GAOYANGNONGYE_PC_USERID')
				}
			} else {
				token = '';
				window.localStorage.removeItem('GAOYANGNONGYE_PC_ACCESS_TOKEN')
				window.localStorage.removeItem('GAOYANGNONGYE_PC_USERINFO')
				window.localStorage.removeItem('GAOYANGNONGYE_PC_USERID')
			}

			var token = window.localStorage.getItem('GAOYANGNONGYE_PC_ACCESS_TOKEN')
			config.headers.csrftoken = baseUrl.TOKEN //csrftoken
			config.headers.AuthorizationWeb = token;
			config.headers.denglutype = 4

			//开发环境显示请求参数
			if (process.env.NODE_ENV === "development") {
				console.log(config.data);
			}
			if (config.method === "post" && config.data) {
				config.data.denglu_type = 4
				var data = {
					encrypted: Encrypt(
						JSON.stringify({
							...config.data,
						})
					),
				};
				config.data = data;
			} else if (config.method === "post_no") {
				config.method = "post";
			}

			return config;
		},
		error => {
			return Promise.error(error);
		})
// 响应拦截器
axios.interceptors.response.use(
	response => {
		if (response.status === 200) {
			//返回数据并解密
			if (response.data.data && response.data.data.length > 0) {
				var d = Decrypt(response.data.data);
				response.data.data = JSON.parse(d);
			}
			//开发环境显示内容
			if (process.env.NODE_ENV === "development") {
				// console.log(response.data);
			}
			// 加上2小时
			var currentTime = new Date();
			currentTime.setHours(currentTime.getHours() + 2);
			window.localStorage.setItem('GAOYANGNONGYE_PC_ACCESS_TOKEN_TIME', currentTime)

			if(response.data.code == 501){
				window.localStorage.removeItem('GAOYANGNONGYE_PC_ACCESS_TOKEN')
				window.localStorage.removeItem('GAOYANGNONGYE_PC_USERINFO')
				window.localStorage.removeItem('GAOYANGNONGYE_PC_USERID')
				router.push('/login/login')
			}else{
				return Promise.resolve(response.data); //进行中
			}			        
		} else {
			return Promise.reject(response); //失败       
		}
	},
	// 服务器状态码不是200的情况
	error => {
		if (error.response.status) {
			switch (error.response.status) {
				// 401: 未登录                
				// 未登录则跳转登录页面，并携带当前页面的路径                
				// 在登录成功后返回当前页面，这一步需要在登录页操作。                
				case 401:
					sessionStorage.clear()
					router.push('/login/login')
					break
					// 403 token过期                
					// 登录过期对用户进行提示                
					// 清除本地token和清空vuex中token对象                
					// 跳转登录页面                
				case 403:
					sessionStorage.clear()
					router.push('/login/login')
					break
					// 404请求不存在                
				case 404:
					break;
					// 其他错误，直接抛出错误提示                
				default:
			}
			return Promise.reject(error.response);
		}
	}
);
/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
const $get = (url, params) => {
	return new Promise((resolve, reject) => {
		axios.get(url, {
				params: params,
			})
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err.data)
			})
	});
}
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
const $post = (url, params) => {
	return new Promise((resolve, reject) => {

		params['user_id'] = params['user_id'] ? params['user_id'] : localStorage.getItem(
			'QISUCRM_PC_USERID');

		axios.post(url, QS.stringify(params)) //是将对象 序列化成URL的形式，以&进行拼接   
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err.data)
			})
	});
}
//下面是将get和post方法挂载到vue原型上供全局使用、
export default {
	install: (app) => {
		app.config.globalProperties['$get'] = $get;
		app.config.globalProperties['$post'] = $post;
		app.config.globalProperties['$axios'] = axios;
	}
}